import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

const { colors, spacing } = THEME;

export const styles = StyleSheet.create({
	addTagDropdownFooter: {
		borderTop: `1px solid ${colors.border.light}`,
		boxSizing: 'border-box',
		padding: '8px 20px',
	},
	addNewTagContainer: {
		alignItems: 'center',
		display: 'flex',
		gap: 8,
	},
	addNewTagLabel: {
		color: colors.text.dark,
		fontSize: 12,
	},
	addNewTagPill: {
		alignItems: 'center',
		background: colors.pill.blue.background,
		borderRadius: 18,
		boxSizing: 'border-box',
		color: colors.text.dark,
		display: 'flex',
		fontSize: 12,
		letterSpacing: '0',
		minHeight: 26,
		padding: `${spacing.xs}px ${spacing.md}px`,
		transition: 'all 300ms linear',
		':hover': {
			opacity: 0.9,
		},
	},
});
